
const HeroSection = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/905422671171?text=Merhaba%20ben%20lhglobalpass.com%20%C3%BCzerinden%20ileti%C5%9Fime%20ge%C3%A7iyorum', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+905422671171';
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/9d5e6c0a04a8cb6ccb9fc7120602cf73.jpg"
          alt="İzmir Vize Danışmanlığı - LH Global Pass"
          className="w-full h-full object-cover object-top"
          loading="eager"
          fetchpriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/80 via-navy/70 to-navy/80"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center py-32">
        {/* Top Badge */}
        <div className="inline-flex items-center gap-3 px-6 py-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full mb-8 animate-fade-in">
          <span className="text-white text-sm font-light tracking-wide">
            12 Yıllık Deneyim | İzmir'in Güvenilir Vize Danışmanı
          </span>
        </div>

        {/* Main Heading */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-4 leading-tight tracking-wide animate-slide-up">
          İzmir Vize Danışmanlık
        </h1>
        <p className="text-2xl md:text-3xl font-semibold text-gold mb-6 animate-slide-up">
          LH Global Pass
        </p>

        {/* Subtitle */}
        <p className="text-lg md:text-xl text-gray-200 font-light mb-12 max-w-3xl mx-auto animate-slide-up-delay">
          Schengen, Amerika, İngiltere ve Tüm Dünya Vizeleriniz İçin Profesyonel Destek
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mb-16 animate-slide-up-delay-2">
          <button
            onClick={handleWhatsApp}
            className="group bg-gold hover:bg-gold-dark text-navy px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-2xl hover:scale-105 flex items-center gap-3 whitespace-nowrap"
            aria-label="WhatsApp ile İletişim"
          >
            <i className="ri-whatsapp-line text-2xl group-hover:scale-110 transition-transform duration-300"></i>
            WhatsApp ile Hızlı İletişim
          </button>
          <button
            onClick={handleCall}
            className="group bg-transparent border-2 border-white hover:bg-white text-white hover:text-navy px-8 py-4 rounded-full text-base font-semibold transition-all duration-300 hover:shadow-2xl hover:scale-105 flex items-center gap-3 whitespace-nowrap"
            aria-label="Telefon ile Ara"
          >
            <i className="ri-phone-line text-2xl group-hover:scale-110 transition-transform duration-300"></i>
            Hemen Ara
          </button>
        </div>

        {/* Trust Indicators */}
        <div className="inline-flex flex-col sm:flex-row items-center gap-8 sm:gap-12 bg-white/10 backdrop-blur-md px-8 py-6 rounded-2xl border border-white/20 animate-fade-in-delay">
          <div className="text-center">
            <div className="text-4xl font-bold text-gold mb-1">12+</div>
            <div className="text-sm text-gray-200 font-light">Yıl Deneyim</div>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20"></div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gold mb-1">5000+</div>
            <div className="text-sm text-gray-200 font-light">Başarılı Başvuru</div>
          </div>
          <div className="hidden sm:block w-px h-12 bg-white/20"></div>
          <div className="text-center">
            <div className="text-4xl font-bold text-gold mb-1">98%</div>
            <div className="text-sm text-gray-200 font-light">Onay Oranı</div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
